import { Dispatch, SetStateAction } from "react";
import { Box, Divider, Stack, Switch, Tooltip, Typography } from "@mui/material";

import { EditableCardRow } from "../../../components/common";

import { useSessionContext } from "../../../contexts/SessionContext";
import { useFormatter } from "../../../utils/useFormatter";
import { NotificationPatch } from "../../../services/scim/profile/NotificationPatch";

interface IProps {
  setIsEditEmailOpen: Dispatch<SetStateAction<boolean>>;
  setIsEditPhoneOpen: Dispatch<SetStateAction<boolean>>;
}

export function CardContact({
  setIsEditEmailOpen,
  setIsEditPhoneOpen,
}: IProps) {
  const { user, fetchUser } = useSessionContext();

  /**
   * Atualiza a preferência de notificações por WhatsApp do usuário
   * - Chama o serviço NotificationPatch para fazer o PATCH no Patient
   * - Em seguida, atualiza os dados do usuário no contexto
   */
  const handleSubmit = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      await NotificationPatch({
        idUser: user?.id,
        operation: "replace",
        valueField: `${e.target.checked}`,
      });
    } catch (err) {
      console.log("Erro ao atualizar notificações:", err);
    } finally {
      fetchUser();
    }
  };

  return (
    <Stack
      sx={{
        border: "1px solid",
        borderColor: "neutral700.main",
        borderRadius: "15px",
      }}
      width="100%"
      paddingTop={2}
    >
      <Typography
        variant="h5"
        fontWeight="500"
        paddingBottom={3}
        paddingLeft={5}
      >
        Contato
      </Typography>
      <EditableCardRow
        title="E-mail"
        titleContext={user?.email}
        onClick={() => {
          setIsEditEmailOpen(true);
        }}
      />
      <Divider sx={{ marginLeft: 5 }} />
      <EditableCardRow
        title="Telefone"
        titleContext={useFormatter.formatPhoneNumber(user?.phone)}
        onClick={() => {
          setIsEditPhoneOpen(true);
        }}
      />
      <Divider sx={{ marginLeft: 5 }} />
      {/* Bloco de notificações por WhatsApp */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingX: 5,
          paddingY: 2,
        }}
      >
        <Typography variant="body1">
          Notificações por WhatsApp
        </Typography>
        <Tooltip
          title={
            user?.notificationAgree === "true"
              ? "Desativar notificações"
              : "Ativar notificações"
          }
          arrow
        >
          <Switch
            defaultChecked={user?.notificationAgree === "true"}
            onChange={(e) => handleSubmit(e)}
          />
        </Tooltip>
      </Box>
    </Stack>
  );
}
